import type { BusinessBuilderAttemptAjaxItem } from './business-builder-attempt.backend-model';
import type { BusinessBuilderAttempt } from './business-builder-attempt.model';

export function transformBusinessBuilderAttempt(
  attempt: BusinessBuilderAttemptAjaxItem,
): BusinessBuilderAttempt {
  return {
    id: attempt.id,
    createdAt: attempt.createdAt,
    userId: attempt.userId,
    phaseIndex: attempt.phaseIndex,
    projectCount: attempt.projectCount,
    transactionId: attempt.transactionId,
    phasesData: attempt.phasesData,
    workspaceId: attempt.workspaceId,
    workspaceUrl: attempt.workspaceUrl,
    intendedPaymentAmount: attempt.intendedPaymentAmount,
  };
}
